import { CatalogFilterBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { z } from 'zod/v4';

export const customCatalogKindFilter =
  CatalogFilterBlueprint.makeWithOverrides({
    name: 'kind',

    configSchema: {
      initialFilter: z.string().default('component'),

      hiddenKinds: z.array(z.string()).default([]),

      priorityKinds: z.array(z.string()).default([]),

      sortRemainingKinds: z
        .enum(['alphabetical', 'catalog'])
        .default('alphabetical'),

      hidden: z.boolean().default(false),
    },

    factory(originalFactory, { config }) {
      return originalFactory({
        loader: async () => {
          const { CustomEntityKindPicker } = await import(
            './CustomEntityKindPicker'
          );

          return (
            <CustomEntityKindPicker
              initialFilter={config.initialFilter}
              hiddenKinds={config.hiddenKinds}
              priorityKinds={config.priorityKinds}
              sortRemainingKinds={config.sortRemainingKinds}
              hidden={config.hidden}
            />
          );
        },
      });
    },
  });
